import {
  ClientAnalyticsEventType,
  FeatureGateClickedSource,
  FeatureGateCta,
  FeatureGateWithAddons,
  OrgRole,
} from "@hex/common";

import { trackEvent } from "./trackEvent";

export const trackFeatureGateClicked = ({
  cta,
  feature,
  orgRole,
  source = FeatureGateClickedSource.FEATURE_DISABLED,
}: {
  cta?: FeatureGateCta;
  feature: FeatureGateWithAddons | FeatureGateWithAddons[];
  source: FeatureGateClickedSource;
  orgRole?: OrgRole;
}): void => {
  trackEvent(ClientAnalyticsEventType.FEATURE_GATE_CLICKED, {
    featureGateType: feature
      ? Array.isArray(feature)
        ? feature
        : [feature]
      : [],
    triggeredFrom: source,
    orgRole,
    cta: cta ?? undefined,
  });
};
